const STORAGE_KEY = 'cybernovel_editor_settings';

export interface EditorSettings {
  anthropicApiKey: string;
  anthropicModel?: string;
  lightTheme?: boolean;
  autoSave?: boolean;
}

const DEFAULT_SETTINGS: EditorSettings = {
  anthropicApiKey: '',
  anthropicModel: '',
  lightTheme: false,
  autoSave: true,
};

export function getEditorSettings(): EditorSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<EditorSettings>;
    return {
      anthropicApiKey: typeof parsed.anthropicApiKey === 'string' ? parsed.anthropicApiKey : '',
      anthropicModel: typeof parsed.anthropicModel === 'string' ? parsed.anthropicModel : '',
      lightTheme: parsed.lightTheme === true,
      autoSave: parsed.autoSave !== false,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveEditorSettings(settings: EditorSettings): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      anthropicApiKey: settings.anthropicApiKey.trim(),
      anthropicModel: settings.anthropicModel?.trim() ?? '',
      lightTheme: settings.lightTheme === true,
      autoSave: settings.autoSave !== false,
    })
  );
}

export function hasAnthropicApiKey(): boolean {
  return Boolean(getEditorSettings().anthropicApiKey.trim());
}
